import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { paymentTypes } from '../../../../../../redux/constants';
import './styles';
import CTAButton from '../../../../../../components/CTAButton';
import SummaryRow from '../../components/OfferSummary/SummaryRow';
import SummaryFinal from '../../components/OfferSummary/SummaryFinal';
import SummarySelect from '../../../../../../components/SelectBox/SummarySelect';
import OfferTypeSelect from '../../../../../../components/SelectBox/OfferTypeSelect';
import LeafDisclaimer from '../../../../../../components/LeafDisclaimer';
import { hasUserSelectedTrim } from '../../../../../../redux/selectors/trim';
import { getVendorParam, getDestinationURLParam, getReferrerURLParam } from '../../../../../../redux/selectors/helios';
import { geti18n, isEmpty } from '../../../../../../utils';
import { createLocateARetailerURL, createRequestAQuoteURL } from '../../../../../../redux/selectors/paymentOptions';

/**
 * Offer Summary Renders the internal card summary listing the individual
 * items and their prices as well as the term/mileage selects inside the card
 */
class OfferSummary extends Component {
  static propTypes = {
    locateARetailerText: PropTypes.string,
    locateARetailerURL: PropTypes.string,
    leadsFormText: PropTypes.string,
    leadsFormURL: PropTypes.string,
    leadsFormMKS: PropTypes.string,
    requestAQuoteText: PropTypes.string,
    requestAQuoteURL: PropTypes.string,
    locateARetailerMKS: PropTypes.string,
    requestAQuoteMKS: PropTypes.string,
    summaryItems: PropTypes.array,
    signingAmount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    monthlyPayment: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    selectedTerm: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    termOptions: PropTypes.array.isRequired,
    changeTermAction: PropTypes.func.isRequired,
    paymentType: PropTypes.string.isRequired,
    selectedMileage: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    selectedDropdownOption: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    mileageOptions: PropTypes.array.isRequired,
    changeMileageAction: PropTypes.func.isRequired,
    changeOfferSelectionAction: PropTypes.func.isRequired,
    financeDropdownOptions: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object
    ]),
    termTitle: PropTypes.string,
    milageTitle: PropTypes.string,
    vendor: PropTypes.string.isRequired,
    destinationURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    referrerURL: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    offerDropdownLabel: PropTypes.string,
    modelLine: PropTypes.string.isRequired,
    brand: PropTypes.string.isRequired,
    leafDefaultDisclaimer: PropTypes.string,
    leafFederalDisclaimer: PropTypes.string,
    cashBackAmount: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    promoTypeId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    isOfferApplied: PropTypes.bool.isRequired,
    trimWasSelected: PropTypes.bool.isRequired

  };
  static defaultProps = {
    locateARetailerText: geti18n('offerPanel.summaryPanel.retailerButton'),
    requestAQuoteText: geti18n('offerPanel.summaryPanel.quoteButton'),
    locateARetailerMKS: geti18n('offerPanel.summaryPanel.retailerButtonMKS'),
    requestAQuoteMKS: geti18n('offerPanel.summaryPanel.quoteButtonMKS'),
    leadsFormText: geti18n('offerPanel.summaryPanel.leadFormButton'),
    leadsFormURL: geti18n('linkPaths.leadFormURL'),
    leadsFormMKS: geti18n('offerPanel.summaryPanel.leadFormButtonMKS'),
    locateARetailerURL: '',
    requestAQuoteURL: '',
    summaryItems: [{ label: 'Label1', value: 20000, className: '' }, { label: 'Label2', value: 500, className: 'blue' }],
    signingAmount: 0,
    monthlyPayment: 0,
    isOpen: true,
    termDisclaimer: geti18n('offerPanel.topPanel.termDisclaimer'),
    termTitle: geti18n('offerPanel.topPanel.termText'),
    cashbackTitle: geti18n('offerPanel.topPanel.cashBackTitle'),
    milageTitle: geti18n('offerPanel.topPanel.mileage'),
    offerDropdownLabel: geti18n('offerTypeDropdown.label'),
    financeDropdownOptions: [],
    leafDefaultDisclaimer: geti18n('offerPanel.summaryPanel.leafDefaultDisclaimer'),
    leafFederalDisclaimer: geti18n('offerPanel.summaryPanel.leafFederalDisclaimer'),
  };

  // Renders the term select dropdown
  renderTermInput() {
    const {
      selectedTerm,
      termOptions,
      changeTermAction,
      termTitle,
    } = this.props;

    // Hide the term input if there arent' any valid options to show.
    // Added this last minute to mimick live with some instances of the offer feed
    // returning invalid term data for offers.
    if (isEmpty(termOptions)) {
      return undefined;
    }
    return (
      <div className="offer-term-wrapper">
        <p className="term-title summary-font"> {termTitle} </p>
        <SummarySelect
          items={termOptions}
          onSelect={changeTermAction}
          textKey="text"
          valueKey="value"
          value={selectedTerm}
          removeLabel
          className="term-select"
        />
      </div>
    )
  }

  // If this is a Lease option then render the mileage select dropdown
  renderMileageInput() {
    const {
      paymentType,
      selectedMileage,
      mileageOptions,
      changeMileageAction,
      milageTitle,
    } = this.props;

    // Dont show mileage for Finance options.
    if (paymentType !== paymentTypes.LEASE) {
      return undefined;
    }

    return (
      <div className="offer-mileage-wrapper">
        <p className="mileage-title summary-font"> {milageTitle} </p>
        <SummarySelect
          items={mileageOptions}
          onSelect={changeMileageAction}
          textKey="text"
          valueKey="value"
          value={selectedMileage}
          removeLabel
          className="mileage-select"
        />
      </div>
    )
  }

  // Renders the Cashback Select dropdown on Finance Offers
  renderOfferTypeInput() {
    const {
      changeOfferSelectionAction,
      paymentType,
      financeDropdownOptions,
      offerDropdownLabel,
      selectedDropdownOption
    } = this.props;
    // Offer Types are for Finance only.
    if (paymentType !== paymentTypes.FINANCING) {
      return undefined;
    }
    return (
      <div className="offer-cashback-wrapper">
        <p className="cashback-title summary-font"> {offerDropdownLabel} </p>
        <OfferTypeSelect
          items={financeDropdownOptions}
          onSelect={changeOfferSelectionAction}
          textKey="text"
          valueKey="value"
          value={selectedDropdownOption}
          removeLabel
          className="offer-type-dropdown"
        />
      </div>
    )
  }

  renderLeafDisclaimer() {
    const {
      modelLine,
      brand,
      leafDefaultDisclaimer,
      leafFederalDisclaimer,
      cashBackAmount,
      promoTypeId,
      paymentType,
      isOfferApplied
    } = this.props;
    let leafDisclaimer = '';
    const cashBackVal = parseInt(cashBackAmount.replace(/[$,]+/g, ''), 10);
    if ((brand === 'nissan') && (modelLine === 'LEF')) {
      if (paymentType === 'LEASE' && isOfferApplied) {
        leafDisclaimer = <LeafDisclaimer text={leafFederalDisclaimer} />
      } else if ((paymentType === 'FINANCE') && (cashBackVal >= 7500) && (promoTypeId === '15')) {
        leafDisclaimer = <LeafDisclaimer text={leafFederalDisclaimer} />
      } else {
        leafDisclaimer = <LeafDisclaimer text={leafDefaultDisclaimer} />
      }
    }
    return (
      leafDisclaimer
    )
  }

  // Renders the 2 CTA buttons on the bottom of the card
  renderCTAS = () => {
    const {
      locateARetailerText,
      locateARetailerURL,
      requestAQuoteText,
      requestAQuoteURL,
      monthlyPayment,
      paymentType,
      vendor,
      destinationURL,
      referrerURL,
      trimWasSelected,
      locateARetailerMKS,
      requestAQuoteMKS,
      leadsFormMKS,
      leadsFormText,
      leadsFormURL,
      brand
    } = this.props;

    //                  ***** HELIOS INTEGRATION *****
    // Logic to use the destination and referrer URls as sent in from Helios
    // Takes in the destination URL from the query string and places it into the CTA's
    /* eslint-disable */
    const retailerURL = (vendor === 'helios' && referrerURL && !trimWasSelected) ? referrerURL : locateARetailerURL;
    const quoteURL = (vendor === 'helios' && destinationURL && !trimWasSelected) ? destinationURL : requestAQuoteURL;
    const firstCTAClass = brand === 'nissan' ? '' : 'secondary';
    const secondCTAClass = brand === 'nissan' ? 'secondary' : '';
    return (
      <div className="pe-option-buttons">
        <CTAButton title={leadsFormText} url={leadsFormURL} linkName={leadsFormMKS} className={firstCTAClass} />
        <CTAButton title={locateARetailerText} url={retailerURL} linkName={locateARetailerMKS} className={secondCTAClass} monthlyPayment={monthlyPayment} optionType={paymentType} />
        <CTAButton title={requestAQuoteText} url={quoteURL} linkName={requestAQuoteMKS} className={secondCTAClass} monthlyPayment={monthlyPayment} optionType={paymentType} />
      </div>
    )
    /* eslint-enable */
  };

  render() {
    const {
      summaryItems,
      signingAmount,
      monthlyPayment,
    } = this.props;
    const lineItems = summaryItems
      .filter(item => (item.value !== undefined))
      .map(item => <SummaryRow
        key={item.label}
        label={item.label}
        total={item.value}
        classNames={item.className}
      />);
    return (
      <div className="offer-summary-wrapper heading-third">
        <div className="offer-summary-rows">
          {this.renderTermInput()}
          {this.renderMileageInput()}
          {this.renderOfferTypeInput()}
          {lineItems}
        </div>
        <SummaryFinal
          signingAmount={signingAmount}
          monthlyAmount={monthlyPayment}
        />
        {this.renderCTAS()}
        {this.renderLeafDisclaimer()}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({ //eslint-disable-line
  locateARetailerURL: createLocateARetailerURL(state),
  requestAQuoteURL: createRequestAQuoteURL(state),
  vendor: getVendorParam(state),
  destinationURL: getDestinationURLParam(state),
  referrerURL: getReferrerURLParam(state),
  trimWasSelected: hasUserSelectedTrim(state)
});

export default connect(mapStateToProps)(OfferSummary);



/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/components/OfferSummary/index.js
 **/